import React from 'react'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import ModuloIscrizione from './ModuloIscrizione'
import ModuloRinnovo from './ModuloRinnovo'
import Prenotazione from './Prenotazione'
const RECAPTCHAKEY = "6LcJ4aopAAAAANDtfwWO0F9sZHuStaFcUWbBCwdS";

function App() {
  return (    
  <BrowserRouter>
    <Routes>
      <Route exact path='/' element={<GoogleReCaptchaProvider
                reCaptchaKey={RECAPTCHAKEY}
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "head",
                }}
              >
                <ModuloIscrizione />
              </GoogleReCaptchaProvider>}/>
      <Route path='/iscrizione' element={<GoogleReCaptchaProvider
                reCaptchaKey={RECAPTCHAKEY}
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "head",
                }}
              >
                <ModuloIscrizione />
              </GoogleReCaptchaProvider>}/>
      <Route path='/rinnovo' element={<GoogleReCaptchaProvider
                reCaptchaKey={RECAPTCHAKEY}
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "head",
                }}
              >
                <ModuloRinnovo/>
              </GoogleReCaptchaProvider>}/>
      <Route path='/prenotazione' element={<GoogleReCaptchaProvider
                reCaptchaKey={RECAPTCHAKEY}
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "head",
                }}
              >
              <Prenotazione/>
              </GoogleReCaptchaProvider>}/>
    </Routes>
  </BrowserRouter>
  );
}

export default App;
